import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$window, $body} from '../Constants';

/**
 * Javascript Wrapper for the Header HTMLElement
 */
class Header extends HtmlElement {

	constructor($element) {
		super($element);

		this.transitionEnabled = false;
		this.$flagsWrapper = $('.tx-ig-flags');
	}

	onReady() {
		this.toggleScrolled();
		this.adjustPosition();
	}

	onResize() {
		this.toggleScrolled();
		this.adjustPosition();
	}

	onLoad() {
		this.enableTransition();
	}

	onScroll() {
		this.toggleScrolled();
	}

	/**
	 * Toggle the headers "scrolled" state
	 */
	toggleScrolled() {
		if($window.width() > Settings.headerScrollToggleMinWidth && Settings.headerScrolledAt > 0) {
			// add scrolled class when below headerScrolledAt value or remove when above
			this.$element.toggleClass(Settings.classScrolled, $window.scrollTop() >= Settings.headerScrolledAt);
		}
	}

	/**
	 * Adjust the top Position of the Header to make Space for the flagsWrapper
	 */
	adjustPosition() {
		if(this.flagsWrapperIsAboveHeader()) {
			this.$element.css('top', this.$flagsWrapper.height());
		} else {
			this.$element.css('top', '');
		}
	}

	/**
	 * Enable Transitions on the Header
	 */
	enableTransition() {
		if(!this.transitionEnabled) {
			this.$element.addClass(Settings.classTransitionEnabled);
		}
	}

	/**
	 * Add the height of the flagsWrapper to the reported Header height if it is above the header
	 * @param {boolean} margin
	 * @returns {Number}
	 */
	getHeight(margin = false) {
		let height = super.getHeight(margin);

		if(this.flagsWrapperIsAboveHeader()) {
			height += this.$flagsWrapper.height();
		}

		return height;
	}

	/**
	 * Check if the flagsWrapper is above the Header
	 * @returns {boolean}
	 */
	flagsWrapperIsAboveHeader() {
		return (this.$flagsWrapper.length && this.$flagsWrapper.offset().top <= this.$element.offset().top);
	}
}

export default (new Header($body.find('header')));